import React from 'react';

export function HelpImportLawDrills() {
  return (
    <div style={{ maxWidth: 640, margin: '3rem auto', padding: '0 1.5rem', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem', color: '#0f172a' }}>
        How to import your Law Drills results
      </h1>
      <ol style={{ lineHeight: 1.8, color: '#374151', paddingLeft: '1.25rem' }}>
        <li>Open Law Drills and go to your session results.</li>
        <li>Select all the text in your results table (Ctrl+A or Cmd+A).</li>
        <li>Copy it (Ctrl+C or Cmd+C).</li>
        <li>In SQETrack, go to the <strong>MCQ Results</strong> tab.</li>
        <li>Select <strong>Law Drills</strong> as your provider.</li>
        <li>Paste your results into the text box.</li>
        <li>Review the topic matches, then confirm the import.</li>
      </ol>
      <p style={{ marginTop: '1.5rem', color: '#6b6b68', fontSize: '0.875rem' }}>
        SQETrack maps each Law Drills question to the corresponding FLK topic. Your scores feed into the priority dashboard and blended confidence calculations.
      </p>
      <a href="/app" style={{ display: 'inline-block', marginTop: '1.5rem', color: '#3B82F6', fontWeight: 600, textDecoration: 'none' }}>
        Back to SQETrack
      </a>
    </div>
  );
}
